$(function() {
  // 再検索
  if ($('#archive-job').length) {
    let resultSlugs = []
    $('.js-results').each(function(index, element) {
      const array = $(element)
        .data('slug')
        .split(', ')
      resultSlugs = resultSlugs.concat(array)
    })
    console.log('resultSlugs:' + resultSlugs)

    let activeAreas = []
    let activeKinds = []
    let activeParticulars = []
    $('.c-search-details__checkbox').each(function(index, element) {
      if (resultSlugs.includes($(element).val())) {
        /* decodeURIしなくてもよい */
        $(element).prop('checked', true)
        const elementData = $(element)
          .closest($('.c-search-details'))
          .data()
        switch (elementData.type) {
          case 'area':
            activeAreas.push(elementData.num)
            break
          case 'kind':
            activeKinds.push(elementData.num)
            break
          case 'particular':
            activeParticulars.push(elementData.num)
          default:
        }
      }
    })
    // 検索後にタブを開けておきたかったらコメントアウト外す
    /*$.each(activeAreas, (index, value) => {
      $('.tab-area' + value)
        .find($('.c-search__item__tab'))
        .addClass('active')
      $('.opened-area-' + value).addClass('open')
    })
    $.each(activeKinds, (index, value) => {
      $('.tab-kind' + value)
        .find($('.c-search__item__tab'))
        .addClass('active')
      $('.opened-kind-' + value).addClass('open')
      $('#listKind').addClass('open-kind-' + value)
    })
    $.each(activeParticulars, (index, value) => {
      $('.tab-particular' + value)
        .find($('.c-search__item__tab'))
        .addClass('active')
      $('.opened-particular-' + value).addClass('open')
      $('#listParticular').addClass('open-particular-' + value)
    })*/

    if ($('#js-results-s').length) {
      const freeWord = $('#js-results-s').text()
      $('input[name="s"]').val(freeWord)
    }
  }

  // 検索条件を変更するボタン
  $('#btnCange').on('click', function() {
    $(this).hide()
    $('#searchHide').show()
  })

  // タブクリック
  $('.js-open-button1').on('click', function() {
    if (!$('.opened-area-1').hasClass('open')) {
      $(this)
        .parents('ul.c-search__item__input-items')
        .addClass('open-area-1')
      $('.js-open-button1').addClass('active')
      $('.opened-area-1').addClass('open')
      $('.opened-area-2').removeClass('open')
      $('.opened-area-3').removeClass('open')
      $('.opened-area-4').removeClass('open')
    } else {
      $(this)
        .parents('ul.c-search__item__input-items')
        .removeClass('open-area-1')
      $('.js-open-button1').removeClass('active')
      $('.opened-area-1').removeClass('open')
    }
  })

  $('.js-open-button2').on('click', function() {
    if (!$('.opened-area-2').hasClass('open')) {
      $(this)
        .parents('ul.c-search__item__input-items')
        .addClass('open-area-2')
      $('.js-open-button2').addClass('active')
      $('.opened-area-2').addClass('open')
    } else {
      $(this)
        .parents('ul.c-search__item__input-items')
        .removeClass('open-area-2')
      $('.js-open-button2').removeClass('active')
      $('.opened-area-2').removeClass('open')
    }
  })

  $('.js-open-button3').on('click', function() {
    if (!$('.opened-area-3').hasClass('open')) {
      $(this)
        .parents('ul.c-search__item__input-items')
        .addClass('open-area-3')
      $('.js-open-button3').addClass('active')
      $('.opened-area-3').addClass('open')
    } else {
      $(this)
        .parents('ul.c-search__item__input-items')
        .removeClass('open-area-3')
      $('.js-open-button3').removeClass('active')
      $('.opened-area-3').removeClass('open')
    }
  })

  $('.js-open-button4').on('click', function() {
    if (!$('.opened-area-4').hasClass('open')) {
      $(this)
        .parents('ul.c-search__item__input-items')
        .addClass('open-area-4')
      $('.js-open-button4').addClass('active')
      $('.opened-area-4').addClass('open')
    } else {
      $(this)
        .parents('ul.c-search__item__input-items')
        .removeClass('open-area-4')
      $('.js-open-button4').removeClass('active')
      $('.opened-area-4').removeClass('open')
    }
  })

  $('.js-open-button5').on('click', function() {
    if (!$('.opened-area-5').hasClass('open')) {
      $(this)
        .parents('ul.c-search__item__input-items')
        .addClass('open-area-5')
      $('.js-open-button5').addClass('active')
      $('.opened-area-5').addClass('open')
    } else {
      $(this)
        .parents('ul.c-search__item__input-items')
        .removeClass('open-area-5')
      $('.js-open-button5').removeClass('active')
      $('.opened-area-5').removeClass('open')
    }
  })

  $('.js-open-button6').on('click', function() {
    if (!$('.opened-area-6').hasClass('open')) {
      $(this)
        .parents('ul.c-search__item__input-items')
        .addClass('open-area-6')
      $('.js-open-button6').addClass('active')
      $('.opened-area-6').addClass('open')
    } else {
      $(this)
        .parents('ul.c-search__item__input-items')
        .removeClass('open-area-6')
      $('.js-open-button6').removeClass('active')
      $('.opened-area-6').removeClass('open')
    }
  })

  $('.js-open-button7').on('click', function() {
    if (!$('.opened-area-7').hasClass('open')) {
      $(this)
        .parents('ul.c-search__item__input-items')
        .addClass('open-area-7')
      $('.js-open-button7').addClass('active')
      $('.opened-area-7').addClass('open')
    } else {
      $(this)
        .parents('ul.c-search__item__input-items')
        .removeClass('open-area-7')
      $('.js-open-button7').removeClass('active')
      $('.opened-area-7').removeClass('open')
    }
  })

  $('.js-open-button8').on('click', function() {
    if (!$('.opened-area-8').hasClass('open')) {
      $(this)
        .parents('ul.c-search__item__input-items')
        .addClass('open-area-8')
      $('.js-open-button8').addClass('active')
      $('.opened-area-8').addClass('open')
    } else {
      $(this)
        .parents('ul.c-search__item__input-items')
        .removeClass('open-area-8')
      $('.js-open-button8').removeClass('active')
      $('.opened-area-8').removeClass('open')
    }
  })

  $('.js-open-button9').on('click', function() {
    if (!$('.opened-kind-1').hasClass('open')) {
      $(this)
        .parents('ul.c-search__item__input-items')
        .addClass('open-kind-1')
      $('.js-open-button9').addClass('active')
      $('.opened-kind-1').addClass('open')
    } else {
      $(this)
        .parents('ul.c-search__item__input-items')
        .removeClass('open-kind-1')
      $('.js-open-button9').removeClass('active')
      $('.opened-kind-1').removeClass('open')
    }
  })

  $('.js-open-button10').on('click', function() {
    if (!$('.opened-kind-2').hasClass('open')) {
      $(this)
        .parents('ul.c-search__item__input-items')
        .addClass('open-kind-2')
      $('.js-open-button10').addClass('active')
      $('.opened-kind-2').addClass('open')
    } else {
      $(this)
        .parents('ul.c-search__item__input-items')
        .removeClass('open-kind-2')
      $('.js-open-button10').removeClass('active')
      $('.opened-kind-2').removeClass('open')
    }
  })

  $('.js-open-button11').on('click', function() {
    if (!$('.opened-particular-1').hasClass('open')) {
      $(this)
        .parents('ul.c-search__item__input-items')
        .removeClass()
        .addClass('c-search__item__input-items')
        .addClass('open-particular-1')
      $('.opened-particular-1').addClass('open')
    } else {
      $(this)
        .parents('ul.c-search__item__input-items')
        .removeClass('open-particular-1')
      $('.opened-particular-1').removeClass('open')
    }
  })
})
